module.exports = {
	"id": "com.agnibho.com.pdosage.data",
	"timestamp": 1490700677124,
	"version": 20170328.1,
	"dosage": [
		{
			"name": "Aciclovir",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "2y",
							"dose": {
								"perKg": 80,
								"adult": [
									3200,
									3200
								],
								"unit": "mg",
								"txt": "per day q 6 hr x 5d",
								"comment": "for Varicella in immunocompetent host"
							}
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "2y",
							"dose": {
								"perKg": 80,
								"adult": [
									3200,
									3200
								],
								"unit": "mg",
								"txt": "per day q 8 hr x 7-10d",
								"comment": "for Varicella in immunocompromised host"
							}
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "12y",
							"dose": {
								"val": 200,
								"unit": "mg",
								"txt": "q 4 hr x 5d",
								"comment": "for H. Simplex"
							}
						}
					]
				},
				{
					"mode": "IV",
					"gen": true,
					"range": [
						{
							"max": "3m",
							"dose": {
								"perKg": 10,
								"unit": "mg",
								"txt": "q 8 hr x 14-21d",
								"comment": "for Neonatal HSV"
							}
						}
					]
				},
				{
					"mode": "IV",
					"gen": true,
					"range": [
						{
							"min": "3m",
							"max": "12y",
							"dose": {
								"perKg": 20,
								"unit": "mg",
								"txt": "q 8 hr x 21d",
								"comment": "for HSV encephalitis"
							}
						}
					]
				}
			],
			"comment": "Conc. for IV- 7mg/ml. Available forms- Tab 200mg,400mg,800mg; Susp 400mg/5ml; Inj 250mg; Ointment 3%(eye),5%(skin)."
		},
		{
			"name": "Amikacin",
			"form": [
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"perKg": [
							15,
							20
						],
						"adult": [
							1500,
							1500
						],
						"unit": "mg",
						"txt": "IM or IV per day q 8-12 hr",
						"comment": "infusion over 1 hr"
					}
				},
				{
					"mode": "Inj",
					"content": "100mg",
					"dose": {
						"approx": [
							100,
							"15*bw",
							"20*bw"
						],
						"adult": [
							15,
							15
						],
						"unit": "vial",
						"txt": "",
						"comment": ""
					}
				},
				{
					"mode": "Inj",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"15*bw",
							"20*bw"
						],
						"adult": [
							6,
							6
						],
						"unit": "vial",
						"txt": "",
						"comment": ""
					}
				},
				{
					"mode": "Inj",
					"content": "500mg",
					"dose": {
						"approx": [
							500,
							"15*bw",
							"20*bw"
						],
						"adult": [
							3,
							3
						],
						"unit": "vial",
						"txt": "",
						"comment": ""
					}
				}
			],
			"comment": "Adjust dose in renal failure."
		},
		{
			"name": "Amlodipine",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							0.05,
							0.5
						],
						"adult": [
							5,
							10
						],
						"unit": "mg",
						"txt": "OD"
					}
				},
				{
					"mode": "Oral",
					"content": "2.5mg",
					"dose": {
						"approx": [
							2.5,
							"0.05*bw",
							"0.5*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "tab",
						"txt": "OD"
					}
				},
				{
					"mode": "Oral",
					"content": "5mg",
					"dose": {
						"approx": [
							5,
							"0.05*bw",
							"0.5*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "OD"
					}
				},
				{
					"mode": "Oral",
					"content": "10mg",
					"dose": {
						"approx": [
							10,
							"0.05*bw",
							"0.5*bw"
						],
						"adult": [
							0.5,
							1
						],
						"unit": "tab",
						"txt": "OD"
					}
				}
			]
		},
		{
			"name": "Amoxycillin / Clavulinic Acid",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							25,
							50
						],
						"adult": [
							250,
							500
						],
						"unit": "mg",
						"txt": "q 8-12 hr"
					}
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": [
							50,
							100
						],
						"adult": [
							1200,
							1200
						],
						"unit": "mg",
						"txt": "q 6-8 hr"
					}
				},
				{
					"mode": "Tab",
					"content": "375mg",
					"dose": {
						"approx": [
							250,
							"25*bw",
							"50*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "625mg",
					"dose": {
						"approx": [
							500,
							"25*bw",
							"50*bw"
						],
						"adult": [
							0.5,
							1
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "156mg/5ml",
					"dose": {
						"perKg": [
							1,
							2
						],
						"adult": [
							10,
							20
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "150mg",
					"dose": {
						"approx": [
							125,
							"50*bw",
							"100*bw"
						],
						"adult": [
							8,
							8
						],
						"unit": "amp",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "300mg",
					"dose": {
						"approx": [
							250,
							"50*bw",
							"100*bw"
						],
						"adult": [
							4,
							4
						],
						"unit": "amp",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "600mg",
					"dose": {
						"approx": [
							500,
							"50*bw",
							"100*bw"
						],
						"adult": [
							2,
							2
						],
						"unit": "amp",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "1.2gm",
					"dose": {
						"approx": [
							1000,
							"50*bw",
							"100*bw"
						],
						"adult": [
							1,
							1
						],
						"unit": "amp",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Azithromycin",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "6m",
							"max": "12y",
							"dose": [
								{
									"perKg": 10,
									"unit": "mg",
									"txt": "per day on day 1"
								},
								{
									"perKg": 5,
									"unit": "mg",
									"txt": "per day on next 4 days"
								},
								{
									"perKg": 30,
									"unit": "mg",
									"txt": "single dose"
								},
								{
									"perKg": 20,
									"unit": "mg",
									"txt": "per day x 7-14 days for enteric fever"
								},
								{
									"perKg": 20,
									"unit": "mg",
									"txt": "single dose for cholera"
								}
							]
						},
						{
							"min": "12y",
							"dose": [
								{
									"val": 500,
									"unit": "mg",
									"txt": "OD x 3 days"
								},
								{
									"val": 500,
									"unit": "mg",
									"txt": "on day 1"
								},
								{
									"val": 250,
									"unit": "mg",
									"txt": "on day 2-5",
									"comment": "total dose 1.5 gm"
								},
								{
									"val": 1000,
									"unit": "mg",
									"txt": "single dose"
								}
							]
						}
					]
				}
			],
			"comment": "Available forms- Tab 100mg,250mg,500mg; Syr 100mg/5ml,200mg/5ml"
		},
		{
			"name": "Cefixime",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 8,
						"adult": [
							400,
							400
						],
						"unit": "mg",
						"txt": "OD or BD"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 20,
						"adult": [
							400,
							400
						],
						"unit": "mg",
						"txt": "OD or BD",
						"comment": "for enteric fever"
					}
				},
				{
					"mode": "Tab",
					"content": "50mg",
					"dose": {
						"approx": [
							50,
							"8*bw"
						],
						"adult": [
							8,
							8
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "100mg",
					"dose": {
						"approx": [
							100,
							"8*bw"
						],
						"adult": [
							4,
							4
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "200mg",
					"dose": {
						"approx": [
							200,
							"8*bw"
						],
						"adult": [
							2,
							2
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "400mg",
					"dose": {
						"approx": [
							400,
							"8*bw"
						],
						"adult": [
							1,
							1
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "100mg/5ml",
					"dose": {
						"perKg": 0.4,
						"adult": [
							20,
							20
						],
						"unit": "ml",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Ceftriaxone",
			"form": [
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"perKg": [
							50,
							75
						],
						"adult": [
							1000,
							1000
						],
						"unit": "mg",
						"txt": "IV q 12-24 hr"
					}
				},
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"perKg": 50,
						"adult": [
							1000,
							1000
						],
						"unit": "mg",
						"txt": "IV q 12 hr",
						"comment": "for Meningitis. Max 4 gm."
					}
				},
				{
					"mode": "Inj",
					"gen": true,
					"range": [
						{
							"max": "1y",
							"dose": {
								"perKg": [
									25,
									50
								],
								"adult": [
									125,
									125
								],
								"unit": "mg",
								"txt": "single IM or IV for gonococcal ophthalmia neonatoram."
							}
						}
					]
				},
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"val": 125,
						"unit": "mg",
						"txt": "single IM",
						"comment": "prophylaxis for N. meningitidis."
					}
				},
				{
					"mode": "Inj",
					"content": "125mg",
					"dose": {
						"approx": [
							125,
							"50*bw",
							"75*bw"
						],
						"adult": [
							8,
							8
						],
						"unit": "vial",
						"txt": ""
					}
				},
				{
					"mode": "Inj",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"50*bw",
							"75*bw"
						],
						"adult": [
							4,
							4
						],
						"unit": "vial",
						"txt": ""
					}
				},
				{
					"mode": "Inj",
					"content": "500mg",
					"dose": {
						"approx": [
							500,
							"50*bw",
							"75*bw"
						],
						"adult": [
							2,
							2
						],
						"unit": "vial",
						"txt": ""
					}
				},
				{
					"mode": "Inj",
					"content": "1000mg",
					"dose": {
						"approx": [
							1000,
							"50*bw",
							"75*bw"
						],
						"adult": [
							1,
							1
						],
						"unit": "vial",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Cefuroxime",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							20,
							30
						],
						"adult": [
							500,
							1000
						],
						"unit": "mg",
						"txt": "per day q 12 hr PC"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 40,
						"adult": [
							500,
							1000
						],
						"unit": "mg",
						"txt": "per day q 12 hr PC",
						"comment": "for enteric fever"
					}
				},
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"perKg": [
							100,
							150
						],
						"adult": [
							2250,
							2250
						],
						"unit": "mg",
						"txt": "per day IM or IV"
					}
				},
				{
					"mode": "Inj",
					"gen": true,
					"range": [
						{
							"min": "12y",
							"dose": {
								"perKg": 1.5,
								"unit": "gm",
								"txt": "q 8 hr IM or IV",
								"comment": "for severe infections"
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "125mg",
					"dose": {
						"approx": [
							125,
							"20*bw",
							"30*bw"
						],
						"adult": [
							4,
							8
						],
						"unit": "tab",
						"txt": "per day q 12 hr PC"
					}
				},
				{
					"mode": "Tab",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"20*bw",
							"30*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "tab",
						"txt": "per day q 12 hr PC"
					}
				},
				{
					"mode": "Tab",
					"content": "500mg",
					"dose": {
						"approx": [
							500,
							"20*bw",
							"30*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "per day q 12 hr PC"
					}
				},
				{
					"mode": "Syr",
					"content": "125mg/5ml",
					"dose": {
						"perKg": [
							0.8,
							1.2
						],
						"adult": [
							20,
							40
						],
						"unit": "ml",
						"txt": "per day q 12 hr PC"
					}
				},
				{
					"mode": "Inj",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"100*bw",
							"150*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "vial",
						"txt": "per day q 6-8 hr IV or IM"
					}
				}
			],
			"comment": "Also available Inj 750mg and 1.5gm."
		},
		{
			"name": "Diazepam",
			"form": [
				{
					"mode": "Inj",
					"gen": true,
					"range": [
						{
							"max": "1m",
							"dose": [
								{
									"val": [
										1,
										5
									],
									"unit": "mg",
									"txt": "slow IV for Neonatal Tetanus, max 2mg/kg, every 2-4 hrs alternating with Chlorpromazine."
								},
								{
									"perKg": [
										15,
										40
									],
									"unit": "mg",
									"txt": "per day continuous infusion for Neonatal Tetanus."
								}
							]
						},
						{
							"min": "1m",
							"max": "5y",
							"dose": {
								"perKg": [
									0.2,
									0.5
								],
								"limit": [
									5,
									5
								],
								"unit": "mg",
								"txt": "IV or IM as anti-convulsant, maybe repeated q 3-5 mins"
							}
						},
						{
							"min": "5y",
							"dose": {
								"perKg": [
									0.2,
									0.5
								],
								"limit": [
									10,
									10
								],
								"unit": "mg",
								"txt": "IV or IM as anti-convulsant, maybe repeated q 3-5 mins"
							}
						}
					]
				},
				{
					"mode": "Oral/IV/IM",
					"gen": true,
					"range": [
						{
							"max": "12y",
							"dose": {
								"perKg": [
									0.1,
									0.2
								],
								"unit": "mg",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": [
								{
									"val": [
										2,
										10
									],
									"unit": "mg",
									"txt": "per day for anxiety"
								},
								{
									"val": [
										5,
										10
									],
									"unit": "mg",
									"txt": "at bedtime for Insomnia"
								},
								{
									"val": [
										10,
										30
									],
									"unit": "mg",
									"txt": "for muscle spasms & premedication"
								}
							]
						}
					]
				}
			],
			"comment": "Available forms- Tab 2mg,5mg,10mg; Syr 2mg/5ml; Inj 10mg/2ml; Rectal sol 2mg/ml,5mg/5ml; Suppository 2.5mg,5mg"
		},
		{
			"name": "Domperidone",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							0.2,
							0.4
						],
						"adult": [
							10,
							20
						],
						"unit": "mg",
						"txt": "q 4-8 hr"
					}
				},
				{
					"mode": "Tab",
					"content": "10mg",
					"dose": {
						"approx": [
							10,
							"0.2*bw",
							"0.4*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "q 4-8 hr"
					}
				},
				{
					"mode": "Tab",
					"content": "5mg",
					"dose": {
						"approx": [
							5,
							"0.2*bw",
							"0.4*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "tab",
						"txt": "q 4-8 hr"
					}
				},
				{
					"mode": "Susp",
					"content": "5mg/5ml",
					"dose": {
						"perKg": [
							0.2,
							0.4
						],
						"adult": [
							10,
							20
						],
						"unit": "ml",
						"txt": "q 4-8 hr"
					}
				},
				{
					"mode": "Drop",
					"content": "10mg/ml",
					"dose": {
						"perKg": [
							0.02,
							0.04
						],
						"adult": [
							1,
							2
						],
						"unit": "ml",
						"txt": "q 4-8 hr"
					}
				}
			]
		},
		{
			"name": "Drotaverine",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "1y",
							"max": "6y",
							"dose": {
								"val": 20,
								"unit": "mg",
								"txt": "TDS"
							}
						},
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 40,
								"unit": "mg",
								"txt": "TDS"
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									40,
									80
								],
								"unit": "mg",
								"txt": "TDS"
							}
						}
					]
				},
				{
					"mode": "Inj",
					"gen": true,
					"range": [
						{
							"min": "1y",
							"max": "6y",
							"dose": {
								"val": 20,
								"unit": "mg",
								"txt": ""
							}
						},
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 40,
								"unit": "mg",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									40,
									80
								],
								"unit": "mg",
								"txt": ""
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "40mg",
					"range": [
						{
							"min": "1y",
							"max": "6y",
							"dose": {
								"val": 0.5,
								"unit": "tab",
								"txt": ""
							}
						},
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 1,
								"unit": "tab",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									1,
									2
								],
								"unit": "tab",
								"txt": ""
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "80mg",
					"range": [
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 0.5,
								"unit": "tab",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									0.5,
									1
								],
								"unit": "tab",
								"txt": ""
							}
						}
					]
				},
				{
					"mode": "Susp",
					"content": "20mg/5ml",
					"range": [
						{
							"min": "1y",
							"max": "6y",
							"dose": {
								"val": 5,
								"unit": "ml",
								"txt": ""
							}
						},
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 2,
								"unit": "ml",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									2,
									4
								],
								"unit": "ml",
								"txt": ""
							}
						}
					]
				},
				{
					"mode": "Inj",
					"content": "20mg/ml",
					"range": [
						{
							"min": "1y",
							"max": "6y",
							"dose": {
								"val": 1,
								"unit": "ml",
								"txt": ""
							}
						},
						{
							"min": "6y",
							"max": "12y",
							"dose": {
								"val": 2,
								"unit": "ml",
								"txt": ""
							}
						},
						{
							"min": "12y",
							"dose": {
								"val": [
									2,
									4
								],
								"unit": "tab",
								"txt": ""
							}
						}
					]
				}
			]
		},
		{
			"name": "Furosemide",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": [
						{
							"perKg": [
								2,
								6
							],
							"adult": [
								40,
								80
							],
							"unit": "mg",
							"txt": "per day q 12 hr"
						},
						{
							"perKg": [
								1,
								2
							],
							"adult": [
								40,
								80
							],
							"unit": "mg",
							"txt": "per dose q 6-8 hr in emergency"
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "12y",
							"dose": {
								"val": 250,
								"unit": "mg",
								"txt": "q 6 hr in oliguria, max 2gm/dose"
							}
						}
					]
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": [
							1,
							3
						],
						"adult": [
							20,
							40
						],
						"unit": "mg",
						"txt": "per day",
						"comment": "@ 0.1-1.0 mg/kg/hr"
					}
				},
				{
					"mode": "Tab",
					"content": "40mg",
					"dose": {
						"perKg": [
							2,
							6
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "per day"
					}
				},
				{
					"mode": "IV",
					"content": "10mg/ml",
					"dose": {
						"perKg": [
							0.2,
							0.6
						],
						"adult": [
							4,
							8
						],
						"unit": "ml",
						"txt": "per day"
					}
				}
			]
		},
		{
			"name": "Hydroxyzine",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "6m",
							"dose": {
								"perKg": 2,
								"adult": [
									50,
									200
								],
								"unit": "mg",
								"txt": "per day q 6 hr"
							}
						}
					]
				},
				{
					"mode": "IM",
					"gen": true,
					"range": [
						{
							"min": "6m",
							"dose": {
								"perKg": [
									0.5,
									1
								],
								"adult": [
									50,
									200
								],
								"unit": "mg",
								"txt": "q 4-6 hr"
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "10mg",
					"range": [
						{
							"min": "6m",
							"dose": {
								"approx": [
									10,
									"2*bw"
								],
								"adult": [
									5,
									20
								],
								"unit": "tab",
								"txt": "per day q 6 hr"
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "25",
					"range": [
						{
							"min": "6m",
							"dose": {
								"approx": [
									25,
									"2*bw"
								],
								"adult": [
									2,
									8
								],
								"unit": "tab",
								"txt": "per day q 6 hr"
							}
						}
					]
				},
				{
					"mode": "Syr",
					"content": "10mg/5ml",
					"range": [
						{
							"min": "6m",
							"dose": {
								"perKg": 1,
								"adult": [
									25,
									100
								],
								"unit": "ml",
								"txt": "per day q 6 hr"
							}
						}
					]
				},
				{
					"mode": "Drop",
					"content": "6mg/ml",
					"range": [
						{
							"min": "6m",
							"dose": {
								"perKg": 0.33,
								"adult": [
									8.33,
									33.33
								],
								"unit": "ml",
								"txt": "per day q 6 hr"
							}
						}
					]
				},
				{
					"mode": "IM",
					"content": "25mg/ml",
					"range": [
						{
							"min": "6m",
							"dose": {
								"perKg": [
									0.02,
									0.04
								],
								"adult": [
									2,
									8
								],
								"unit": "ml",
								"txt": ""
							}
						}
					]
				}
			]
		},
		{
			"name": "Levosalbutamol",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							0.05,
							0.2
						],
						"adult": [
							1,
							2
						],
						"unit": "mg",
						"txt": "2-3 times a day"
					}
				},
				{
					"mode": "Tab.",
					"content": "1mg",
					"dose": {
						"approx": [
							1,
							"0.05*bw",
							"0.2*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "2-3 times a day"
					}
				},
				{
					"mode": "Tab.",
					"content": "2mg",
					"dose": {
						"approx": [
							2,
							"0.05*bw",
							"0.2*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": "2-3 times a day"
					}
				},
				{
					"mode": "Syr.",
					"content": "1mg/5ml",
					"dose": {
						"perKg": [
							0.25,
							1
						],
						"adult": [
							5,
							10
						],
						"unit": "ml",
						"txt": "2-3 times a day"
					}
				},
				{
					"mode": "Syr.",
					"content": "0.5mg/5ml",
					"dose": {
						"perKg": [
							0.5,
							2
						],
						"adult": [
							10,
							20
						],
						"unit": "ml",
						"txt": "2-3 times a day"
					}
				},
				{
					"mode": "Resp.",
					"range": [
						{
							"min": "2m",
							"max": "6m",
							"dose": {
								"val": "0.31",
								"unit": "mg"
							}
						},
						{
							"min": "6m",
							"max": "1y",
							"dose": {
								"val": "0.63",
								"unit": "mg"
							}
						},
						{
							"min": "2m",
							"dose": {
								"val": "1.25",
								"unit": "mg"
							}
						}
					]
				},
				{
					"mode": "MDI",
					"content": "50mcg/puff",
					"dose": [
						{
							"val": [
								2,
								4
							],
							"unit": "puffs",
							"txt": "upto 3 at 20 mins interval"
						},
						{
							"val": 2,
							"unit": "puffs",
							"txt": "every 4-6 hrs following initial Tx"
						}
					]
				}
			]
		},
		{
			"name": "Metronidazole",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							15,
							20
						],
						"adult": [
							200,
							400
						],
						"unit": "mg",
						"txt": "q 8 hr x 5-7 days for giardiasis"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							35,
							50
						],
						"adult": [
							200,
							400
						],
						"unit": "mg",
						"txt": "q 8 hr x 10 days for amebiasis"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 20,
						"adult": [
							200,
							400
						],
						"unit": "mg",
						"txt": "q 8 hr x 7-10 days for antibiotic associated diarrhea"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 20,
						"adult": [
							200,
							400
						],
						"unit": "mg",
						"txt": "q 6 hr for anerobic infections"
					}
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": 20,
						"adult": [
							200,
							400
						],
						"unit": "mg",
						"txt": "q 6 hr for anerobic infections"
					}
				}
			],
			"comment": "Available forms- Tab 200mg,400mg; Susp 200mg/5ml,100mg/5ml; Inj 500mg/100ml."
		},
		{
			"name": "Ofloxacin",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 15,
						"adult": [
							400,
							800
						],
						"unit": "mg",
						"txt": "per day q 12 hr"
					}
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": [
							5,
							10
						],
						"adult": [
							400,
							800
						],
						"unit": "mg",
						"txt": "per day q 12 hr"
					}
				},
				{
					"mode": "Tab",
					"content": "100mg",
					"dose": {
						"approx": [
							100,
							"15*bw"
						],
						"adult": [
							4,
							8
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "200mg",
					"dose": {
						"approx": [
							200,
							"15*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "400mg",
					"dose": {
						"approx": [
							400,
							"15*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Susp",
					"content": "100mg/5ml",
					"dose": {
						"perKg": 0.75,
						"adult": [
							20,
							40
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "200mg/100ml",
					"dose": {
						"perKg": [
							2.5,
							5
						],
						"adult": [
							200,
							400
						],
						"unit": "ml",
						"txt": "infusion"
					}
				},
				{
					"mode": "IV",
					"content": "400mg/100ml",
					"dose": {
						"perKg": [
							1.25,
							2.5
						],
						"adult": [
							100,
							200
						],
						"unit": "ml",
						"txt": "infusion"
					}
				}
			]
		},
		{
			"name": "Ondansetron",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"min": "3y",
							"max": "4y",
							"dose": {
								"val": 2,
								"unit": "mg",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "4y",
							"max": "11y",
							"dose": {
								"val": 4,
								"unit": "mg",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "8y",
							"dose": {
								"val": 8,
								"unit": "mg",
								"txt": "q 4 hr"
							}
						}
					]
				},
				{
					"mode": "IV",
					"gen": true,
					"range": [
						{
							"min": "3y",
							"dose": {
								"perKg": [
									0.15,
									0.45
								],
								"adult": [
									8,
									8
								],
								"unit": "mg",
								"txt": "q 4 hr slow IV"
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "4mg",
					"range": [
						{
							"min": "3y",
							"max": "4y",
							"dose": {
								"val": 0.5,
								"unit": "tab",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "4y",
							"max": "11y",
							"dose": {
								"val": 1,
								"unit": "tab",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "8y",
							"dose": {
								"val": 2,
								"unit": "tab",
								"txt": "q 4 hr"
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "8mg",
					"range": [
						{
							"min": "4y",
							"max": "11y",
							"dose": {
								"val": 0.5,
								"unit": "tab",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "8y",
							"dose": {
								"val": 1,
								"unit": "tab",
								"txt": "q 4 hr"
							}
						}
					]
				},
				{
					"mode": "Syr",
					"content": "2mg/5ml",
					"range": [
						{
							"min": "3y",
							"max": "4y",
							"dose": {
								"val": 5,
								"unit": "ml",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "4y",
							"max": "11y",
							"dose": {
								"val": 10,
								"unit": "ml",
								"txt": "q 4 hr"
							}
						},
						{
							"min": "8y",
							"dose": {
								"val": 20,
								"unit": "ml",
								"txt": "q 4 hr"
							}
						}
					]
				},
				{
					"mode": "IV",
					"content": "2mg/ml",
					"range": [
						{
							"min": "3y",
							"dose": {
								"perKg": [
									0.08,
									0.22
								],
								"adult": [
									4,
									4
								],
								"unit": "ml",
								"txt": "q 4 hr slow IV"
							}
						}
					]
				}
			]
		},
		{
			"name": "Paracetamol",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": [
						{
							"perKg": 15,
							"adult": [
								500,
								1000
							],
							"unit": "mg",
							"txt": "q 4-6 hr"
						},
						{
							"perKg": 60,
							"adult": [
								4000,
								4000
							],
							"unit": "mg",
							"txt": "maximum in 24 hrs"
						}
					]
				},
				{
					"mode": "Rectal",
					"gen": true,
					"dose": {
						"perKg": 15,
						"adult": [
							500,
							1000
						],
						"unit": "mg",
						"txt": ""
					}
				},
				{
					"mode": "IM",
					"gen": true,
					"dose": {
						"perKg": 5,
						"adult": [
							500,
							1000
						],
						"unit": "mg",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "500mg",
					"dose": {
						"approx": [
							500,
							"15*bw",
							"15*bw"
						],
						"adult": [
							1,
							2
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "650mg",
					"dose": {
						"approx": [
							650,
							"15*bw",
							"15*bw"
						],
						"adult": [
							1,
							1.5
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"15*bw",
							"15*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "1000mg",
					"dose": {
						"approx": [
							1000,
							"15*bw",
							"15*bw"
						],
						"adult": [
							1,
							1
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "125mg/5ml",
					"dose": {
						"perKg": 0.6,
						"adult": [
							20,
							40
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "250mg/5ml",
					"dose": {
						"perKg": 0.3,
						"adult": [
							10,
							20
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "Drop",
					"content": "100mg/ml",
					"dose": {
						"perKg": 0.15,
						"adult": [
							5,
							10
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "Rectal",
					"content": "125mg",
					"dose": {
						"approx": [
							125,
							"15*bw",
							"15*bw"
						],
						"adult": [
							4,
							8
						],
						"unit": "suppositories",
						"txt": ""
					}
				},
				{
					"mode": "Rectal",
					"content": "250mg",
					"dose": {
						"approx": [
							250,
							"15*bw",
							"15*bw"
						],
						"adult": [
							2,
							4
						],
						"unit": "suppositories",
						"txt": ""
					}
				},
				{
					"mode": "IM",
					"content": "150mg/5ml",
					"dose": {
						"perKg": 0.03,
						"adult": [
							3,
							6.5
						],
						"unit": "ml",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Phenytoin",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							5,
							8
						],
						"adult": [
							150,
							300
						],
						"unit": "mg",
						"txt": "per day q 12 hr or single dose",
						"comment": "Increased to max 200-400mg in adults"
					}
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": [
							15,
							20
						],
						"unit": "mg",
						"txt": "Loading dose @ 1mg/kg/min",
						"comment": "diluted in NS, require cardiac monitoring"
					}
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": [
						{
							"perKg": 1.25,
							"adult": [
								1500,
								1500
							],
							"unit": "mg",
							"txt": "q 5min",
							"comment": "Loading dose for arrythmia"
						},
						{
							"perKg": 15,
							"adult": [
								1500,
								1500
							],
							"unit": "mg",
							"txt": "",
							"comment": "Max loading dose for arrythmia"
						},
						{
							"perKg": [
								5,
								10
							],
							"unit": "mg",
							"txt": "per day q 12 hr",
							"comment": "Maintenance dose for arrythmia"
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							5,
							10
						],
						"unit": "mg",
						"txt": "per day q 12 hr",
						"comment": "Maintenance dose for arrythmia"
					}
				},
				{
					"mode": "Tab",
					"content": "50mg",
					"dose": {
						"approx": [
							50,
							"5*bw",
							"8*bw"
						],
						"adult": [
							3,
							6
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "100mg",
					"dose": {
						"approx": [
							100,
							"5*bw",
							"8*bw"
						],
						"adult": [
							1.5,
							3
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Susp",
					"content": "125mg/5ml",
					"dose": {
						"perKg": [
							0.2,
							0.32
						],
						"adult": [
							6,
							12
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "30mg/5ml",
					"dose": {
						"perKg": [
							0.8,
							1.3
						],
						"adult": [
							25,
							50
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "25mg/ml",
					"dose": {
						"perKg": [
							0.6,
							0.8
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "IV",
					"content": "50mg/ml",
					"dose": {
						"perKg": [
							0.3,
							0.4
						],
						"unit": "ml",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Piperacillin / Tazobactum",
			"form": [
				{
					"mode": "IV",
					"gen": true,
					"dose": {
						"perKg": [
							0.3,
							0.4
						],
						"adult": [
							12,
							15
						],
						"unit": "gm",
						"txt": "per day q 8 hr"
					}
				},
				{
					"mode": "IV",
					"content": "4gm/500mg",
					"dose": {
						"approx": [
							4,
							"0.3*bw",
							"0.4*bw"
						],
						"adult": [
							3,
							3.75
						],
						"unit": "vial",
						"txt": "per day q 8 hr"
					}
				}
			]
		},
		{
			"name": "Prednisolone",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							1,
							2
						],
						"adult": [
							60,
							60
						],
						"unit": "mg",
						"txt": "per day q 6-8 hr"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"max": "12y",
							"dose": {
								"perKg": 2,
								"unit": "mg",
								"txt": "per day q 12 hr",
								"comment": "as anti-convulsant in children for 2-6 w, taper over 4-12 w."
							}
						}
					]
				},
				{
					"mode": "Tab",
					"content": "5mg",
					"dose": {
						"approx": [
							5,
							"1*bw",
							"2*bw"
						],
						"adult": [
							12,
							12
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "10mg",
					"dose": {
						"approx": [
							10,
							"1*bw",
							"2*bw"
						],
						"adult": [
							6,
							6
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "20mg",
					"dose": {
						"approx": [
							20,
							"1*bw",
							"2*bw"
						],
						"adult": [
							3,
							3
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "30mg",
					"dose": {
						"approx": [
							30,
							"1*bw",
							"2*bw"
						],
						"adult": [
							2,
							2
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Tab",
					"content": "40mg",
					"dose": {
						"approx": [
							40,
							"1*bw",
							"2*bw"
						],
						"adult": [
							1.5,
							1.5
						],
						"unit": "tab",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "5mg/5ml",
					"dose": {
						"perKg": [
							1,
							2
						],
						"adult": [
							60,
							60
						],
						"unit": "ml",
						"txt": ""
					}
				},
				{
					"mode": "Syr",
					"content": "15mg/5ml",
					"dose": {
						"perKg": [
							0.33,
							0.66
						],
						"adult": [
							20,
							20
						],
						"unit": "ml",
						"txt": ""
					}
				}
			]
		},
		{
			"name": "Ranitidine",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							2,
							4
						],
						"adult": [
							300,
							300
						],
						"unit": "mg",
						"txt": "per day"
					}
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": [
							4,
							8
						],
						"adult": [
							600,
							600
						],
						"unit": "mg",
						"txt": "per day",
						"comment": "in GERD (double dose)"
					}
				},
				{
					"mode": "Inj",
					"gen": true,
					"dose": {
						"perKg": [
							1,
							2
						],
						"adult": [
							200,
							200
						],
						"unit": "mg",
						"txt": "IV per day"
					}
				},
				{
					"mode": "Tab",
					"content": "150mg",
					"dose": {
						"approx": [
							150,
							"2*bw",
							"4*bw"
						],
						"adult": [
							2,
							2
						],
						"unit": "tab",
						"txt": "per day"
					}
				},
				{
					"mode": "Tab",
					"content": "300mg",
					"dose": {
						"approx": [
							300,
							"2*bw",
							"4*bw"
						],
						"adult": [
							1,
							1
						],
						"unit": "tab",
						"txt": "per day"
					}
				},
				{
					"mode": "Syr",
					"content": "75mg/5ml",
					"dose": {
						"perKg": [
							0.13,
							0.26
						],
						"adult": [
							20,
							20
						],
						"unit": "ml",
						"txt": "per day"
					}
				},
				{
					"mode": "Inj",
					"content": "50mg/2ml",
					"dose": {
						"perKg": [
							0.04,
							0.08
						],
						"adult": [
							8,
							8
						],
						"unit": "ml",
						"txt": "IV per day"
					}
				}
			]
		},
		{
			"name": "Valproate",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"dose": [
						{
							"perKg": [
								10,
								15
							],
							"adult": [
								600,
								600
							],
							"unit": "mg",
							"txt": "per day q 12 hr initially"
						},
						{
							"perKg": [
								5,
								10
							],
							"adult": [
								200,
								200
							],
							"unit": "mg",
							"txt": "per day; increment at weekly interval"
						},
						{
							"perKg": 60,
							"adult": [
								5000,
								5000
							],
							"unit": "mg",
							"txt": "per day; maximum dose",
							"comment": "usual adult dose 1-2gm/day"
						}
					]
				},
				{
					"mode": "IV",
					"gen": true,
					"dose": [
						{
							"perKg": 20,
							"unit": "mg",
							"txt": "loading dose"
						},
						{
							"perKg": [
								5,
								10
							],
							"unit": "q 8 hr",
							"txt": "maintenance dose @ 20mg/min max"
						}
					]
				}
			],
			"comment": "Available forms- Tab 200mg,300mg,400mg,500mg; Syr 200mg/5ml; Inj 100mg/ml."
		},
		{
			"name": "Zinc",
			"form": [
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"max": "1y",
							"dose": {
								"perKg": 0.5,
								"unit": "mg",
								"txt": "per day",
								"comment": "for deficiency"
							}
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"range": [
						{
							"max": "6m",
							"dose": {
								"val": 10,
								"unit": "mg",
								"txt": "per day",
								"comment": "for acute and persistent diarrhea > 14 days"
							}
						},
						{
							"min": "6m",
							"dose": {
								"val": 20,
								"unit": "mg",
								"txt": "per day",
								"comment": "for acute and persistent diarrhea > 14 days"
							}
						}
					]
				},
				{
					"mode": "Oral",
					"gen": true,
					"dose": {
						"perKg": 6,
						"adult": [
							220,
							220
						],
						"unit": "mg",
						"txt": "per day",
						"comment": "for acrodermatitis"
					}
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 70
// module chunks = 0